<template>
  <div>
    <input type="text" v-model="question.proposal_type" style="display: none;" />
    <div class="btn-group fullwidth mb-4 mt-4" role="group" aria-label="Basic example">
      <button type="button" class="btn btn-secondary" :class="isActive('simple_choice')" @click="changeTab('simple_choice')">Simple choix</button>
      <button type="button" class="btn btn-secondary" :class="isActive('multiple_choice')" @click="changeTab('multiple_choice')">Multiple choix</button>
      <button type="button" class="btn btn-secondary" :class="isActive('ordered')" @click="changeTab('ordered')">Ordonner</button>
    </div>
    <div class="form-group" v-for="(proposal, index) in question.proposals" :key="index">
      <label :for="getElementID(proposal.value, index)">Réponse {{ index +1 }}</label>
      <div class="input-group">
        <input :id="getElementID(proposal.value, index)" type="text" class="form-control" v-model="proposal.name">
        <div class="input-group-append">
          <div class="input-group-text" v-if="question.proposal_type === 'simple_choice'">
            <input type="radio" :disabled="proposal.name === ''" :checked="proposal.is_valid">
          </div>
          <div class="input-group-text" v-if="question.proposal_type === 'multiple_choice'">
            <input type="checkbox" :disabled="proposal.name === ''" :checked="proposal.is_valid">
          </div>
          <select class="custom-select" v-if="question.proposal_type === 'ordered'" v-model="proposal.order">
            <option :value="nbr" v-for="nbr in question.proposals.length" :key="nbr" :selected="proposal.order === nbr" :disabled="proposal.name === ''">{{ nbr }}</option>
          </select>
        </div>
      </div>
    </div>
    <!-- <div class="form-group" v-for="(answer, index) in question.answers" :key="index">
      <label :for="getElementID(index)">Réponse {{ index +1 }}</label>
      <div class="input-group">
        <input :id="getElementID(index)" type="text" class="form-control" v-model="answer.name">
        <div class="input-group-append">
          <div class="input-group-text" v-if="question.proposal_type === 'simple_choice'" @click="updateSimpleChoiceValidAnswer(index)">
            <input type="radio" :disabled="answer.name == ''" :checked="answer.valid_answer">
          </div>
          <div class="input-group-text" v-if="question.proposal_type === 'multiple_choice'">
            <input type="checkbox" :disabled="answer.name == ''" :checked="answer.valid_answer">
          </div>
          <select class="custom-select" v-if="question.proposal_type === 'ordered'" v-model="answer.ordered">
            <option :value="nbr" v-for="nbr in question.answers.length" :key="nbr" :selected="answer.ordered === nbr" :disabled="answer.name == ''">{{ nbr }}</option>
          </select>
        </div>
      </div>
    </div> -->
    <button type="button" class="btn btn-outline-secondary btn-block mt-4" @click="addAnswer()">Ajouter une réponse</button>
</div>
</template>


<script>
const defaultAnswer = {
  name: '',
  is_valid: false,
  order: 0,
}

export default {
  props: {
    question: Object,
  },

  data() {
    return {
      indexAvailable: []
    }
  },

  methods: {
    getElementID(value, index){
      return `${value}-proposal-${index}`
    },

    updateSimpleChoiceValidAnswer(answerIndex) {
      this.question.answers.map(((a, index) => {
        if (index === answerIndex) {
          a.valid_answer = true
        } else {
          a.valid_answer = false
        }
      }))
    },

    changeTab(tab) {
      this.question.proposal_type = tab
      this.question.proposals = [Object.assign({}, defaultAnswer),  Object.assign({}, defaultAnswer)]
    },

    isActive(type) {
      if (this.question.proposal_type === type) {
        return 'active'
      }
    },

    addAnswer() {
      this.question.proposals.push(Object.assign({}, defaultAnswer))
    }
  },

  mounted() {
    this.question.proposals = [Object.assign({}, defaultAnswer),  Object.assign({}, defaultAnswer)]
  }
}
</script>
